<template>
    <f7-page
        :page-content="false"
        name="Course"
        no-swipeback
        class="onboardingBg withHalfBg course-scroll"
    >
        <f7-navbar
            :title-large="' '"
            inner
            large
            no-hairline
            large-transparent
            inner-class="onboardingBg"
        >

            <f7-nav-left>
                <f7-link
                    v-if="onboardingCompleted > 1 || course.id !== FEELING_PRESENT_IN_YOUR_BODY"
                    icon="ion-ios-arrow-left"
                    @click="goBack()"
                />
            </f7-nav-left>
            <f7-nav-title>{{ course.name }}</f7-nav-title>
            <f7-nav-right />
        </f7-navbar>
        <f7-page-content>
            <h1
                class="center"
                style="margin-top: -30px"
            >{{ topicsIndex[course.topicId].name }}</h1>
            <div
                v-if="topicsIndex[course.topicId].type === 'goal'"
                style="margin-top: -16px; margin-bottom: 20px"
            >
                <f7-link
                    v-if="course.id !== FEELING_PRESENT_IN_YOUR_BODY && !variant"
                    class="center"
                    @click="goToOverview"
                >Show introduction</f7-link>
                <f7-button
                    v-else-if="user.unitsCompleted > 2 && !variant"
                    :color="myTopics.indexOf(course.topicId) > -1 ? 'white' : 'red'"
                    fill
                    round
                    style="z-index: 9; max-width: 230px; margin: 20px auto 16px"
                    @click="addToMyGoals"
                >{{ myTopics.indexOf(course.topicId) === -1 ? 'Add to my goals' : 'Remove from my goals' }}</f7-button>
                <br v-else>
            </div>
            <div id="courseBottom">

                <div
                    class="exploreContentSection"
                    style="min-height: 60vh"
                >
                    <f7-block>
                        <h3
                            class="center"
                            style="margin-top: 40px"
                        >{{ course.name }}</h3>
                        <p
                            v-if="course.description"
                            id="courseDescription"
                            style="margin-top: -10px"
                            v-html="course.description"
                        />
                    </f7-block>
                    <template v-if="loaded">
                        <f7-block v-if="loaded && shownUnits === 0">No units are relevant to you</f7-block>
                        <f7-block
                            v-if="unitsByPack[0] && unitsByPack[0].length"
                            :key="`pack-0`"
                            style="margin: -10px 0 0 0; padding: 0"
                        >
                            <sequential-entrance from-bottom>
                                <template v-for="(unit, i) in unitsByPack[0]">
                                    <unit-card
                                        :unit="unit"
                                        :key="`notic-${unit.id}`"
                                        :visible="true"
                                        :in-card="true"
                                        :index="i"
                                        :disabled="isDisabledOnHome(unit)"
                                        :pack="unitsByPack[0]"
                                        :color="topicsIndex[course.topicId] && topicsIndex[course.topicId].color ? topicsIndex[course.topicId].color : ''"
                                    />
                                </template>
                            </sequential-entrance>
                        </f7-block>
                        <template v-for="pack in course.packs">

                            <f7-block
                                v-if="unitsByPack[pack.id] && unitsByPack[pack.id].length"
                                :key="`pack-${pack.id}`"
                                style="margin: 0; padding: 0"
                            >
                                <h1
                                    v-if="unitsByPack[pack.id] && unitsByPack[pack.id].length"
                                    :key="`pack-${pack.id}-divider`"
                                    style="text-align: center; line-height: 23px; font-size: 27px"
                                ><br>
                                    {{ pack.title }}<br>
                                    <span style="font-size: 16px;">{{ pack.subtitle }}</span><br>
                                </h1>
                                <sequential-entrance from-bottom>
                                    <template v-for="(unit, i) in unitsByPack[pack.id]">
                                        <unit-card
                                            :unit="unit"
                                            :key="`notic2-${unit.id}`"
                                            :visible="true"
                                            :in-card="true"
                                            :disabled="isDisabledOnHome(unit)"
                                            :index="i"
                                            :pack="unitsByPack[pack.id]"
                                            :color="topicsIndex[course.topicId] && topicsIndex[course.topicId].color ? topicsIndex[course.topicId].color : ''"
                                        />
                                    </template>
                                </sequential-entrance>
                            </f7-block>
                        </template>
                        <f7-button
                            v-if="showLoadMore && loaded"
                            @click="getUnits(true)"
                        >Load more units</f7-button>
                        <br style="clear: both">
                        <f7-link
                            v-if="hiddenUnits.length"
                            class="moreLink"
                            @click="toggleHidden"
                        >{{ showHidden ? 'Hide' : 'Show' }} hidden units &mdash;</f7-link>
                        <br
                            v-if="showHidden"
                            style="clear: both"
                        >
                        <div v-if="hiddenUnits.length && showHidden">
                            <f7-block style="color: #686868; margin-top: 0px;">These units have been hidden because they are not relevant to your gender, sexual preference, relationship status or other traits. You can edit your traits in Settings.</f7-block>
                            <f7-block style="margin: 0; padding: 0">
                                <template v-for="(unit, i) in hiddenUnits">
                                    <unit-card
                                        :unit="unit"
                                        :key="`hidden-${unit.id}`"
                                        :visible="true"
                                        :in-card="true"
                                        :disabled="isDisabledOnHome(unit)"
                                        :index="i"
                                        :pack="hiddenUnits"
                                        :color="topicsIndex[course.topicId] && topicsIndex[course.topicId].color ? topicsIndex[course.topicId].color : ''"
                                    />
                                </template>
                            </f7-block>
                        </div>
                        <br style="clear: both">

                        <br>
                    </template>
                </div>
                <f7-block
                    v-if="course.type === 'ask'"
                    style="margin-top: -20px"
                >
                    <f7-button
                        :href="`/submitStory?type=question&courseId=${course.id}`"
                        color="red"
                        fill
                        round
                    >ASK YOUR QUESTION</f7-button>
                </f7-block>
                <div style="height: 120px" />
            </div>
        </f7-page-content>
        <div
            v-if="fullDataIndex[course.topicId].courses.length > 1 && validCourses && !variant"
            class="miniSwiper"
        >
            <f7-swiper
                :params="{slidesOffsetAfter: 20, slidesOffsetBefore: 20, speed:500, initialSlide, slidesPerView: 'auto', spaceBetween: 10, noSwiping: true}"
                :navigation="!isPgap"
            >
                <template v-for="(c, i) in fullDataIndex[course.topicId].courses">
                    <f7-swiper-slide
                        v-if="checkTraits(c) || topicsIndex[course.topicId].type !== 'goal'"
                        :key="c.id"
                        style="width: 100px"
                        class="non-swipe-tile"
                    >

                        <course-card
                            :course="c"
                            :topic="topicsIndex[c.topicId]"
                            :index="i"
                            :link="`/courses/${c.id}`"
                            :key="`tc-${i}`"
                            :locked="false"
                            :is-learn="['learn','goal'].indexOf(c.type) > -1"
                            :disabled="c.comingSoon"
                            :selected="c.id === course.id"
                            :tabbar="true"
                            :small="true"
                        />
                    </f7-swiper-slide>
                </template>
            </f7-swiper>
        </div>

    </f7-page>
</template>

<script>
import _ from 'lodash';

import CourseCard from '../../components/courseCard.vue';
import UnitCard from '../../components/unitCard.vue';

import utils from '../../js/utils';
import {
    BEGIN_THE_REVOLUTION,
    CHANGE_YOUR_LIFE_IDS,
    FEELING_PRESENT_IN_YOUR_BODY,
} from '../../js/constants';

export default {
    store: [
        'api',
        'user',
        'topics',
        'myTopics',
        'topicsIndex',
        'fullDataIndex',
        'courses',
        'unitsIndex',
        'coursesIndex',
        'currentCourse',
        'myTraits',
        'onboardingCompleted'
    ],
    components: {
        CourseCard,
        UnitCard
    },
    data () {
        return {
            currentId: 0,
            initialSlide: 0,
            course: {
                id: 0,
                name: '',
                data: {},
                units: [],
                packs: [],
                nextUp: 0,
                nextUps: []
            },
            showShape: false,
            unitsByPack: [],
            hiddenUnitsByPack: [],
            shownUnits: 0,
            showHidden: false,
            hiddenUnits: [],
            showLoadMore: false,
            loaded: false,
            validCourses: 0,
            variant: 0,
            FEELING_PRESENT_IN_YOUR_BODY,
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    watch: {
        myTraits: function () {
            this.getUnits();
        }
    },
    created: function () {
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        this.variant = parseFloat(localStore.getItem(`experiment-015_course-nav`));
        this.$events.on('change-course-tab', (course) => {
            this.currentId = course.id;
            this.currentCourse = course;
            console.log('set currentcourse vua changetab')
            this.getCourse();
            this.getUnits();
            $$('.course-scroll  .page-content').scrollTop(0, 400);
            this.$events.fire(
                'pageChange',
                {
                    url: `/topics/${this.course.topicId}`,
                    name: this.course.name,
                }
            );
        });
        this.getCourse();
        this.getUnits();
    },
    mounted: function () {
        if (this.coursesIndex[this.currentId]) {
            this.course = this.coursesIndex[this.currentId];
            this.currentCourse = this.course;
            console.log('Set currentcourse via course mounted', this.course.id)
            if (this.fullDataIndex[this.course.topicId] && this.fullDataIndex[this.course.topicId].courses) {
                for (let i = 0; i < this.fullDataIndex[this.course.topicId].courses.length; i++) {
                    const element = this.fullDataIndex[this.course.topicId].courses[i];
                    if (element.id === this.currentId) this.initialSlide = i;
                }
            }
        }
    },
    beforeDestroy: function () {
        this.$events.off('change-course-tab');
    },
    methods: {
        toggleHidden: function () {
            this.showHidden = !this.showHidden;
            this.$events.fire('trackEvent', `show_hidden`, 'ui', this.course.id, 'unit', this.course);
        },
        goBack: function () {
            utils.backIfFirst(this);
        },
        isDisabledOnHome: function (unit) {
            if (unit.id === BEGIN_THE_REVOLUTION) return false;
            if (this.onboardingCompleted === 1 && CHANGE_YOUR_LIFE_IDS.includes(unit.id)) return false;
            if (this.onboardingCompleted < 2) return true;
            return false;
        },
        goToOverview: function () {
            if (this.$f7router.history[this.$f7router.history.length - 2] === `/topics/${this.course.topicId}`) {
                this.$f7router.view.router.back();
            } else {
                this.$f7router.view.router.navigate(`/topics/${this.course.topicId}`);
            }
        },
        checkTraits: function (unit) {
            return utils.checkTraits(this.myTraits, unit);
        },
        getValidCourses: function () {
            this.validCourses = 0;
            for (let i = 0; i < this.fullDataIndex[this.course.topicId].courses.length; i++) {
                const element = this.fullDataIndex[this.course.topicId].courses[i];
                if (this.checkTraits(element)) this.validCourses++;
            }
        },
        getCourse: function () {
            this.$events.fire(
                'trackEvent',
                'course_view',
                'progress',
                this.course.id,
                this.course.name,
                this.course
            );
            if (this.coursesIndex[this.currentId]) {
                this.course = this.coursesIndex[this.currentId];
                return this.getValidCourses();
            }
            // leave old course for unpublished or smth...
            f7.preloader.show();
            this.$http.get(`${this.api}/courses/${this.currentId}`).then(
                response => {
                    this.course = response.body || {};
                    this.getValidCourses();
                    f7.preloader.hide();
                },
                response => {
                    f7.preloader.hide();
                    console.error(response.body.message || 'Unknown error 1103');
                }
            );
        },
        addToMyGoals: function () {
            if (this.myTopics.indexOf(this.course.topicId) > -1) {
                if (this.myTopics.length > 0) this.myTopics.splice(this.myTopics.indexOf(this.course.topicId), 1);
                this.$events.fire('trackEvent', `topic_removed`, 'content', this.course.topicId, this.topicsIndex[this.course.topicId].name, this.topicsIndex[this.course.topicId]);
            } else {
                this.myTopics.push(this.course.topicId);
                this.$events.fire('trackEvent', `topic_added`, 'content', this.course.topicId, this.topicsIndex[this.course.topicId].name, this.topicsIndex[this.course.topicId]);
            }
            this.$http.post(`${this.api}/users/${this.user.id}/topics`, {
                topicIds: this.myTopics
            }).then(
                () => {
                    console.log('topics saved');
                },
                response => {
                    console.error(response.body.message || 'Unknown error');
                }
            );
        },
        getUnits: function (append) {
            if (!append) {
                this.loaded = false;
                if ([107, 108].indexOf(this.course.id) > -1) {
                    this.course.units = [];
                }
            }
            this.showLoadMore = false;
            const loadPacks = () => {
                this.shownUnits = 0;
                this.hiddenUnits = [];
                this.hiddenUnitsByPack = [];
                if (this.course && this.course.packs) {
                    for (let i = 0; i < this.course.packs.length; i++) {
                        this.unitsByPack[this.course.packs[i].id] = [];
                        this.hiddenUnitsByPack[this.course.packs[i].id] = 0;
                    }
                }
                this.unitsByPack[0] = [];
                this.hiddenUnitsByPack[0] = 0;
                if (!this.course || !this.course.units) return window.location.reload();
                for (let i = 0; i < this.course.units.length; i++) {
                    let unit = this.unitsIndex[this.course.units[i].id];
                    if (!unit) unit = this.course.units[i];
                    unit.position = 0;
                    if (unit.courses) {
                        for (let j = 0; j < unit.courses.length; j++) {
                            const element = unit.courses[j];
                            if (this.currentCourse && this.currentCourse.id === element.courseId) {
                                unit.packId = unit.courses[j].packId;
                                unit.position = unit.courses[j].position;
                            }
                        }
                    }
                    if (this.course.type !== 'learn' && this.course.type !== 'goal') unit.packId = 0;
                    if (!unit.packId) unit.packId = 0;
                    if (!this.unitsByPack[unit.packId]) this.unitsByPack[unit.packId] = [];
                    if (!this.checkTraits(unit)) {
                        this.hiddenUnits.push(unit);
                        this.hiddenUnitsByPack[unit.packId]++;
                    } else {
                        this.unitsByPack[unit.packId].push(unit);
                        this.shownUnits++;
                    }
                }
                for (let i = 0; i < this.unitsByPack.length; i++) {
                    this.unitsByPack[i] = _.sortBy(this.unitsByPack[i], [
                        (unit) => {
                            return unit.position;
                        },
                    ]);
                }
            };
            if (!append) loadPacks(this.course.units);
            if (append || !this.course.units.length) {
                let sort = ['listen', 'ask', 'play', 'blog'].includes(this.course.type) ? 'recent' : '';
                this.$http.get(`${this.api}/courses/${this.currentId}/units?sort=${sort}&offset=${append ? this.course.units.length : 0}`).then(
                    response => {
                        if (append) {
                            this.course.units = this.course.units.concat(response.body);
                        } else {
                            this.course.units = response.body || [];
                        }
                        this.loaded = true;
                        loadPacks(this.course.units);
                        if (response.body.length > 19) this.showLoadMore = true;
                    },
                    response => {
                        console.error(response.body.message || 'Unknown error 1104');
                        utils.failedRequest('main', response);
                    }
                );
            } else {
                this.loaded = true;
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}

.exploreContentSection {
    position: relative;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    background-color: @darkBackground;
    background-image: url('../../img/0.4/bgwave.png');
    // background-size: 307px 11px;
    background-size: 460.5px 16.5px;
    background-position: top left;
    background-repeat: repeat-x;
    &.hasReverse:before {
        position: absolute;
        bottom: 0px;
        content: '';
        width: 100vw;
        height: 16.5px;
        background-position: bottom left;
        background-size: 460.5px 16.5px;
        background-image: url('../../img/0.4/bgwave.png');
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}
.theme-dark {
    .exploreContentSection {
        background-color: #1c1c1d;

        background-image: url('../../img/0.4/bgwavedark.png');
    }
}
.miniSwiper {
    // background-color: rgba(
    //     var(--f7-toolbar-bg-color-rgb, var(--f7-bars-bg-color-rgb)),
    //     var(--f7-bars-translucent-opacity)
    // );
    // -webkit-backdrop-filter: saturate(180%) blur(var(--f7-bars-translucent-blur));
    // backdrop-filter: saturate(180%) blur(var(--f7-bars-translucent-blur));
    background-image: url('../../img/1.4.0/goalwave.svg');
    background-position: top right;
    background-repeat: repeat-x;
    background-size: 480px 40px;
    z-index: 3000;
    height: ~'calc(150px+env(safe-area-inset-bottom))';
    padding-top: 19px;
    padding-bottom: 0px;
    position: absolute;
    bottom: 0px;
    width: 100vw;
    .swiper-container {
        height: ~'calc(140px+env(safe-area-inset-bottom))';
        padding-bottom: env(safe-area-inset-bottom);
        background-color: #dacdc5;
    }
}
.theme-dark {
    .miniSwiper {
        background-image: url('../../img/1.4.0/goalwavedark.svg');
        .swiper-container {
            background-color: #1c1c1d;
        }
    }
}
.moreLink {
    font-size: 15px;
    color: @coral;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    float: right;
    z-index: 100;
    position: relative;
}
</style>
